import React from 'react';
import classNames from 'classnames';

type Props = {
  onClick: (index: number) => void;
  index: number;
  activeIndex: number;
  children: React.ReactNode;
  className?: string;
};

export const TabLink = (props: Props) => {
  const handler = () => {
    if (props.index !== props.activeIndex) {
      props.onClick(props.index);
    }
  };

  return (
    <a
      onClick={handler}
      onKeyPress={handler}
      role='button'
      tabIndex={props.index}
      className={classNames(
        'vault-navigation__item vault-navigation__item--secondary',
        {
          'vault-navigation__item--active': props.index === props.activeIndex,
        },
        props.className,
      )}
    >
      {props.children}
    </a>
  );
};
